export interface ReactProps {
  className?: string;
}
